import { useMemo } from 'react'

import { useOptionalOrgsOverview } from '@/components/pursuits/orgs-overview/context'

import { useActiveOrgId } from '@/hooks/organization/useActiveOrgId'

import type { UUID } from '@/types/Id'

export type PursuitScopeMode = 'single' | 'multi'

export interface PursuitScope {
  orgIds: UUID[]
  mode: PursuitScopeMode
  isMultiOrg: boolean
  /** For routes that need a single org. Falls back to first selected in multi-org. */
  primaryOrgId: UUID | ''
}

// Prefer over useActiveOrgId for pursuits subtree; works in single- and multi-org.
export const usePursuitScope = (): PursuitScope => {
  const overview = useOptionalOrgsOverview()
  const { activeOrgId } = useActiveOrgId()

  return useMemo<PursuitScope>(() => {
    if (overview) {
      return {
        orgIds: overview.effectiveOrgIds,
        mode: 'multi',
        isMultiOrg: true,
        primaryOrgId: overview.effectiveOrgIds[0] ?? '',
      }
    }
    return {
      orgIds: activeOrgId ? [activeOrgId] : [],
      mode: 'single',
      isMultiOrg: false,
      primaryOrgId: activeOrgId,
    }
  }, [overview, activeOrgId])
}
